module.exports = __webpack_public_path__ + "assets/img/09568ad2ca77ea32137417780b92e67d.png";